import { useEffect } from 'react'
import { fetchEducationEvents } from '../actions'
import * as selectors from '../selectors'
import { useSelector, useDispatch } from 'react-redux'

/**
 * @returns array of all events attached to current merchant,
 *  e.g. ['MERCHANT_CREATED', 'TRANSACTIONS_REQUESTED']
 */
function useEducationProfileEvents() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchEducationEvents())
  }, [])
  const merchantEducationEvents = useSelector(selectors.merchantEducationEvents)
  return merchantEducationEvents && merchantEducationEvents.map(event => event.eventType)
}

export default useEducationProfileEvents
